export default __webpack_public_path__ + "static/media/6.e235828d.jpg";